import api from './api';

class CMSService {
    constructor() {
        this.baseURL = '/cms/api';
    }

    async getPages(params = {}) {
        const response = await api.get(`${this.baseURL}/pages/`, { params });
        return response.data;
    }

    async getPage(id) {
        const response = await api.get(`${this.baseURL}/pages/${id}/`);
        return response.data;
    }

    async createPage(data) {
        const response = await api.post(`${this.baseURL}/pages/`, data);
        return response.data;
    }

    async updatePage(id, data) {
        const response = await api.patch(`${this.baseURL}/pages/${id}/`, data);
        return response.data;
    }

    async deletePage(id) {
        await api.delete(`${this.baseURL}/pages/${id}/`);
    }

    async publishPage(id) {
        const response = await api.post(`${this.baseURL}/pages/${id}/publish/`);
        return response.data;
    }

    async unpublishPage(id) {
        const response = await api.post(`${this.baseURL}/pages/${id}/unpublish/`);
        return response.data;
    }

    async reorderBlocks(pageId, blockIds) {
        const response = await api.post(`${this.baseURL}/pages/${pageId}/reorder_blocks/`, {
            block_ids: blockIds
        });
        return response.data;
    }

    async createBlock(data) {
        const response = await api.post(`${this.baseURL}/blocks/`, data);
        return response.data;
    }

    async updateBlock(id, data) {
        const response = await api.patch(`${this.baseURL}/blocks/${id}/`, data);
        return response.data;
    }

    async deleteBlock(id) {
        await api.delete(`${this.baseURL}/blocks/${id}/`);
    }

    async getChromes(params = {}) {
        const response = await api.get(`${this.baseURL}/chrome/`, { params });
        return response.data;
    }

    async createChrome(data) {
        const response = await api.post(`${this.baseURL}/chrome/`, data);
        return response.data;
    }

    async updateChrome(id, data) {
        const response = await api.patch(`${this.baseURL}/chrome/${id}/`, data);
        return response.data;
    }

    async deleteChrome(id) {
        await api.delete(`${this.baseURL}/chrome/${id}/`);
    }

    async getSiteSettings() {
        const response = await api.get(`${this.baseURL}/settings/`);
        return response.data;
    }

    async updateSiteSettings(content) {
        const response = await api.patch(`${this.baseURL}/settings/`, { content });
        return response.data;
    }

    async uploadStaticSite(file) {
        const formData = new FormData();
        formData.append('file', file);
        const response = await api.post(`${this.baseURL}/static-site/`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
        return response.data;
    }

    async deleteStaticSite() {
        const response = await api.delete(`${this.baseURL}/static-site/`);
        return response.data;
    }

    async getStaticSiteFiles() {
        const response = await api.get(`${this.baseURL}/static-site/files/`);
        return response.data;
    }

    async getStaticSiteFile(path) {
        const response = await api.get(`${this.baseURL}/static-site/file/`, { params: { path } });
        return response.data;
    }

    async saveStaticSiteFile(path, content) {
        const response = await api.put(`${this.baseURL}/static-site/file/`, { path, content });
        return response.data;
    }

    async replaceStaticSiteFile(path, file) {
        const formData = new FormData();
        formData.append('path', path);
        formData.append('file', file);
        const response = await api.post(`${this.baseURL}/static-site/file/`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
        return response.data;
    }

    async deleteStaticSiteFile(path) {
        const response = await api.delete(`${this.baseURL}/static-site/file/`, { params: { path } });
        return response.data;
    }

    async createStaticSiteFolder(path) {
        const response = await api.post(`${this.baseURL}/static-site/folder/`, { path });
        return response.data;
    }

    async deleteStaticSiteFolder(path) {
        const response = await api.delete(`${this.baseURL}/static-site/folder/`, { params: { path } });
        return response.data;
    }

    async renameStaticSitePath(path, newPath) {
        const response = await api.post(`${this.baseURL}/static-site/rename/`, {
            path, new_path: newPath
        });
        return response.data;
    }

    async downloadStaticSiteZip() {
        const response = await api.get(`${this.baseURL}/static-site/download/`, { responseType: 'blob' });
        return response.data;
    }

    async getMenus() {
        const response = await api.get(`${this.baseURL}/menus/`);
        return response.data;
    }

    async createMenu(data) {
        const response = await api.post(`${this.baseURL}/menus/`, data);
        return response.data;
    }

    async updateMenu(id, data) {
        const response = await api.patch(`${this.baseURL}/menus/${id}/`, data);
        return response.data;
    }

    async deleteMenu(id) {
        await api.delete(`${this.baseURL}/menus/${id}/`);
    }

    async getPublicNav() {
        const response = await api.get(`${this.baseURL}/public/pages/`);
        return response.data;
    }

    async getPublicPage(slug) {
        const response = await api.get(`${this.baseURL}/public/pages/${slug}/`);
        return response.data;
    }

    async getPublicPosts(limit = 20) {
        const response = await api.get(`${this.baseURL}/public/pages/posts/`, {
            params: { limit }
        });
        return response.data;
    }

    async getPublicHome() {
        const response = await api.get(`${this.baseURL}/public/pages/home/`);
        return response.data;
    }

    async uploadMedia(file) {
        const formData = new FormData();
        formData.append('file', file);
        formData.append('title', file.name);
        const response = await api.post('/library/upload/', formData, {
            headers: { 'Content-Type': 'multipart/form-data' }
        });
        return response.data;
    }

    async submitTradeLead(data) {
        const response = await api.post('/crm/api/leads/public-submit/', data);
        return response.data;
    }
}

const cmsService = new CMSService();
export default cmsService;
